export const langs = [
    { value: "es", label: "Spanish" },
    { value: "ar", label: "Arabic" },
    { value: "fr", label: "French" },
  
  ]